import {EntityService} from '../../../service/EntityService';

export class StoreService extends EntityService {

  static entity = 'app/store';
}
